import { ICONS } from '../../constants/icons';
import hreflangs from '../_hreflang/index';
import sortHreflangs from '../_hreflang/sortHrefLangs';

const HERO_DATA = {
  picture: {
    avif: {
      fallback: '/images/piekno-zaczyna-sie-od-zdrowia-390.avif',
      810:     '/images/piekno-zaczyna-sie-od-zdrowia-1200.avif',
      1440:    '/images/piekno-zaczyna-sie-od-zdrowia-1440.avif',
      1920:    '/images/piekno-zaczyna-sie-od-zdrowia-1920.avif',
    },
    webp: {
      fallback: '/images/piekno-zaczyna-sie-od-zdrowia-390.webp',
      810:     '/images/piekno-zaczyna-sie-od-zdrowia-1200.webp',
      1440:    '/images/piekno-zaczyna-sie-od-zdrowia-1440.webp',
      1920:    '/images/piekno-zaczyna-sie-od-zdrowia-1920.webp',
    },
    default: { // png/jpg
      fallbak: '/images/piekno-zaczyna-sie-od-zdrowia-390.png',
      810:     '/images/piekno-zaczyna-sie-od-zdrowia-1200.png',
      1440:    '/images/piekno-zaczyna-sie-od-zdrowia-1440.png',
      1920:    '/images/piekno-zaczyna-sie-od-zdrowia-1920.png',
    },
  },
  rating: {
    icon: 'svg',
    value: '4.92',
    count: '(3853 zweryfikowanych opinii)',
  },
  heading: 'Piękno zaczyna<br />się od zdrowia.',
  subheading:
    'Autorskie suplementy premium, które wspierają skórę, energię i codzienny komfort – naturalnie, każdego dnia.',
  button: {
    label: 'Zobacz produkty',
    href: 'https://shop.natu.care/collections',
  },
  buttonSecondary: {
    label: 'Poznaj Black Month',
    href: 'https://shop.natu.care/pages/hub'
  }    
};

const MEDIA_BAR_DATA = {
  label: 'OFICJALNY PARTNER',
  partners: [
    {
      id: 'partner-vogue',
      logo: {
        alt: 'Logo Vogue',
        name: 'v4_medibar_vogue'
      },
      description: '„Doskonale uzupełni codzienną pielęgnacje, wspierając jędrność i promienność skóry, wzmacniając włosy i paznokcie”'
    },
    {
      id: 'partner-elle',
      logo: {
        name: 'v4_medibar_elle'
      },
      description: '„Jeden dziennie i będziesz piękna bez końca”'
    },
    {
      id: 'partner-wysokie-obcasy',
      logo: {
        name: 'v4_medibar_wysokieobcasy'
      },
      description: '„Natu.Care wierzy, że sekretem długiego życia jest równowaga fizyczna i psychiczna. Czystość umysłu stawia na równi ze zdrowiem ciała.”'
    }
  ]
}

const makeCategoriesPicture = name => ({
    mobile: {
      webp: `/images/${name}-mobile.webp`,
      avif: `/images/${name}-mobile.avif`,
      fallback: `/images/${name}-mobile.jpg`,
    },
    desktop: {
      webp: `/images/${name}-desktop.webp`,
      avif: `/images/${name}-desktop.avif`,
      fallback: `/images/${name}-desktop.jpg`,
    },
  });
const CATEGORIES_DATA = {
  heading: 'Znajdź rozwiązanie dla siebie',
  items: [
    {
      heading: 'Skóra, włosy i paznokcie',
      link: 'https://shop.natu.care/collections#skora-wlosy-i-paznokcie',
      picture: makeCategoriesPicture('skora-wlosy-paznokcie')
    },
    {
      heading: 'Sylwetka',
      link: 'https://shop.natu.care/collections#ksztaltowanie-sylwetki-cel',
      picture: makeCategoriesPicture('sylwetka')
    },
    {
      heading: 'Jelita i metabolizm',
      link: 'https://shop.natu.care/collections#jelita-i-metabolizm',
      picture: makeCategoriesPicture('jelita-i-metabolizm')
    },
    {
      heading: 'Odporność',
      link: 'https://shop.natu.care/collections#odpornosc',
      picture: makeCategoriesPicture('odpornosc')
    },
    {
      heading: 'Balans i samopoczucie',
      link: 'https://shop.natu.care/collections#balans-i-samopoczucie',
      picture: makeCategoriesPicture('balans-i-samopoczucie')
    },
    {
      heading: 'Witaminy i minerały',
      link: 'https://shop.natu.care/collections#witaminy-i-mineraly',
      picture: makeCategoriesPicture('witaminy-i-mineraly')
    }
  ]
  
}

const STANDARDS_DATA = {
  heading: 'Najwyższe standardy.<br /> <i>Realne efekty</i>.',
  // button: {
  //   label: 'Poznaj nasze standardy',
  //   href: '#'
  // },
  backgroundVideo: {
    src: '/images/standards.mp4',
    type: 'video/mp4'
  },
  items: [
    {
      heading: 'Udowodniona skuteczność',
      description: 'Składniki o działaniu potwierdzonym w badaniach klinicznych.'
    },
    {
      heading: 'Czysty skład',
      description: 'Wolne od metali ciężkich, glutenu i GMO, przebadane w niezależnym laboratorium J.S. Hamilton'
    },
    {
      heading: 'Najwyższa jakość produkcji',
      description: 'W Polsce, zgodnie z normami GMP i HACCP (bezpieczeństwo żywności)'
    },
    {
      heading: 'Certyfikowani dostawcy',
      description: 'Starannie wyselekcjonowane składniki aktywne z Europy'
    },
    {
      heading: 'Eksperckie formuły',
      description: 'Opracowane przez dietetyków i dopracowane w skutecznych dawkach'
    }
  ]
};

const RESEARCH_DATA = {
  heading: 'Skuteczność potwierdzona <i>badaniami</i>',
  tabs: [
    {
      label: 'Kolagen',
      title: 'Kolagen Premium',
      heading: 'Codzienna pielęgnacja od wewnątrz - wspiera jędrność i nawilżenie skóry, włosy pełne blasku i mocniejsze paznokcie.',
      stats: [
        {
          value: '+21%',
          description: 'Jędrniejsza skóra*'
        },
        {
          value: '-20%',
          description: 'Mniej widoczne zmarszczki*'
        },
        {
          value: '96%',
          description: 'Kobiet potwierdziło mocniejsze i gęstsze włosy*'
        }
      ],
      buttons: [
        {
          label: 'Przejdź do produktu',
          href: 'https://shop.natu.care/products/kolagen-rise-shine'
        }
      ],
      caption: '*BADANIA APARATUROWE. Brak metali ciężkich i zbędnych<br />dodatków, każda partia testowana w niezależnym laboratorium J.S. Hamilton',
      image: {
        desktop: '/images/badania-kolagen.png',
        alt: 'Opakowanie produktu Kolagen'
      }
    },
    {
      label: 'Slim Boost',
      title: 'Slim Boost',
      heading: 'Zaawansowana formuła z SelectSIEVE® Libra - klinicznie przebadanym składnikiem, który wspiera kontrolę apetytu i redukcję tkanki tłuszczowej.',
      stats: [
        {
          value: '-13,9%',
          description: 'mniej tkanki tłuszczowej już po 56 dniach (badanie kliniczne)'
        },
        {
          value: '-2,9%',
          description: 'niższe BMI po 8 tygodniach (badanie kliniczne)'
        },
        {
          value: '-8%',
          description: 'mniejszy apetyt już po 14 dniach (badanie kliniczne)'
        }
      ],
      buttons: [
        {
          label: 'Przejdź do produktu',
          href: 'https://shop.natu.care/products/slim-boost'
        }
      ],
      caption: '*brak metali ciężkich i zbędnych dodatków, każda partia testowana w&nbsp;niezależnym laboratorium J.S. Hamilton',
      image: {
        desktop: '/images/badania-slim-boost.png',
        alt: 'Opakowanie produktu Slim Boost'
      } 
    },
    {
      label: 'Omega-3',
      title: 'Omega-3',
      heading: 'Najczystsze wsparcie serca, mózgu i odporności - z dzikich sardeli, w najlepiej przyswajalnej formie trójglicerydów (TG).',
      stats: [
        {
          value: '+90%',
          description: 'lepsza przyswajalność niż standardowe formy EE'
        },
        {
          value: '6,5',
          description: 'ultra niski wskaźnik utlenienia TOTOX = gwarancja świeżości oleju'
        },
        {
          value: '100%',
          description: 'oleju z certyfikatem zrównoważonego rybołówstwa'
        }                
      ],
      buttons: [
        {
          label: 'Przejdź do produktu',
          href: 'https://shop.natu.care/products/natu-care-omega-3-tg'
        }
      ],
      caption: '*brak metali ciężkich i zbędnych dodatków, każda partia testowana w niezależnym laboratorium J.S. Hamilton',
      image: {
        desktop: '/images/badania-omega-3.png',
        alt: 'Opakowanie produktu Omega-3'
      } 
    },
    {
      label: 'Maślan sodu',
      title: 'Maślan Sodu',
      heading: 'Najsilniejsze wsparcie mikrobiomu i zdrowia jelit',
      stats: [
        {
          value: '1200 mg',
          description: 'najwyższa dzienna dawka na rynku'
        },
        {
          value: '100% ',
          description: 'skutecznego uwalniania dzięki markowej kapsułce DR Caps®'
        },
        {
          value: '96%',
          description: 'klientek poleciłoby produkt bliskiej osobie'
        }
      ],
      buttons: [
        {
          label: 'Sprawdź produkt',
          href: 'https://shop.natu.care/products/maslan-sodu-premium-1200-mg'
        }
      ],
      caption: '*brak metali ciężkich i zbędnych dodatków, każda partia testowana w niezależnym laboratorium J.S. Hamilton',
      image: {
        desktop: '/images/badania-maslan-sodu.png',
        alt: 'Opakowanie produktu Maślan Sodu'
      } 
    }
  ]
}

const SUBSCRIPTION_DATA = {
  heading: 'Subskrypcja.<br /><i>Twój komfort każdego dnia</i>',
  items: [
    {
      heading: '-20% Taniej',
      text: 'Zawsze płacisz mniej - bez kodów i polowania na promocje.',
      icon: 'v4_discount'
    },
    {
      heading: 'Dostawa  gratis',
      text: 'Twoje ulubione produkty trafiają prosto pod drzwi, bez dodatkowych kosztów.',
      icon: 'v4_delivery'
    },
    {
      heading: 'Prezent do kadego odnowwienia',
      text: 'Upominki przy każdym odnowieniu subskrypcji.',
      icon: 'v4_gift'
    }
  ],
  cta: {
    label: 'Odkryj komfort subskrypcji',
    href: 'https://shop.natu.care/pages/subskrypcja'
  }
};

const REVIEWS_DATA = {
  heading: 'Prawdziwe efekty. Zaufanie tysięcy kobiet.',
  link: {
    label: 'Zobacz wszystkie opinie',
    href: 'https://natu.care/pl/opinie'
  },
  trustmate: {
    rating: 4.92,
    label: '(3853 zweryfikowanych opinii)'
  },
  items: [
    {
      id: 'review-video-1',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-mango-1.mp4'
    },
    {
      id: 'review-video-6',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-shot-1.mp4'
    },
    {
      id: 'review-video-14',
      src: 'http://cdn-resources.natu.care/videos/slim-boost-1.mp4'
    },
    {
      id: 'review-video-2',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-jezyna-1.mp4'
    },
    {
      id: 'review-video-11',
      src: 'http://cdn-resources.natu.care/videos/colostrum-1.mp4'
    },
    {
      id: 'review-video-9',
      src: 'http://cdn-resources.natu.care/videos/adaptogeny-1.mp4'
    },
    {
      id: 'review-video-4',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-truskawka-1.mp4'
    },
    {
      id: 'review-video-13',
      src: 'http://cdn-resources.natu.care/videos/magnez-1.mp4'
    },
    {
      id: 'review-video-7',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-shot-2.mp4'
    },
    {
      id: 'review-video-10',
      src: 'http://cdn-resources.natu.care/videos/adaptogeny-2.mp4'
    },
    {
      id: 'review-video-12',
      src: 'http://cdn-resources.natu.care/videos/colostrum-2.mp4'
    },
    {
      id: 'review-video-3',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-mango-2.mp4'
    },
    {
      id: 'review-video-8',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-shot-3.mp4'
    },
    {
      id: 'review-video-15',
      src: 'http://cdn-resources.natu.care/videos/slim-boost-2.mp4'
    },
    {
      id: 'review-video-5',
      src: 'http://cdn-resources.natu.care/videos/kolagen-premium-truskawka-2.mp4'
    }
  ]
}

const data = {
  hrefLang: sortHreflangs(hreflangs, 'pl'),
  schema: {
    siteName: {
      name: 'Natu.Care',
      url: 'https://natu.care/pl',
      potentialAction: {
        target: 'https://shop.natu.care/search?q={search_term_string}',
        queryInput: 'required name=search_term_string'
      }
    }
  },

  mediaBar: MEDIA_BAR_DATA,
  hero: HERO_DATA,
  categories: CATEGORIES_DATA,
  standards: STANDARDS_DATA,
  research: RESEARCH_DATA,
  reviews: REVIEWS_DATA,
  subscription: SUBSCRIPTION_DATA,

  products: {
    heading: 'Poznaj nasze produkty'
  },
  features: {
  items: [
    'Bez laktozy',
    'Bez glutenu',
    'Bez GMO',
    'Bez konserwantów',
    'Bez sztucznych barwników',
    'Bez soi',
    'Bez metali ciężkich'
  ],
  },
  trustmatewidget: {
    widgetId: 'cce418cc-5262-46a7-be5b-14e9b979188a'
  }

};

export default data;
